<template>
  <div class="row">
    <div class="col-md-3">
      <form class="needs-validation" ref="form" id="form">
        <div class="form-group">
          <!-- part for operatorid -->
          <label class="mb-0" for="Operator">Operator: </label>
          <select class="form-control" v-model="operator" required>
            <option
              v-for="operator in operators"
              :key="operator.id"
              :value="operator.id"
            >
              {{ operator.username }}
            </option>
          </select>
        </div>

        <!-- part for Adhesive force Frontside-->
        <div class="form-group">
          <label class="mb-0" for="AdhesiveForceFront"
            >Haftkraft Vorderseite [N]</label
          >
          <input
            type="text"
            class="form-control"
            v-model="adhesiveForceFront"
            id="AdhesiveForceFront"
            placeholder="1.1-1.3"
            required
          />
        </div>

        <!-- part for Adhesive force Backside-->
        <div class="form-group">
          <label class="mb-0" for="AdhesiveForceBack"
            >Haftkraft Hinterseite [N]</label
          >
          <input
            type="text"
            class="form-control"
            v-model="adhesiveForceBack"
            id="AdhesiveForceBack"
            placeholder="2-3"
            required
          />
        </div>

        <!-- part for Lubrication Frontside-->
        <div class="form-group">
          <label class="mb-0" for="LubricationFront"
            >Benetzung Vorderseite [%]</label
          >
          <input
            type="text"
            class="form-control"
            v-model="lubricationFront"
            id="LubricationFront"
            placeholder="80"
            required
          />
        </div>

        <!-- part for Lubrication Backside-->
        <div class="form-group">
          <label class="mb-0" for="LubricationBack"
            >Benetzung Hinterseite [%]</label
          >
          <input
            type="text"
            class="form-control"
            v-model="lubricationBack"
            id="LubricationBack"
            placeholder="95"
            required
          />
        </div>

        <!-- part for isSiliciumBreakoutsFront -->
        <div class="mb-2 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isSiliciumBreakoutsFront"
            value=""
            id="SiliciumBreakoutsFront"
          />
          <label class="form-check-label" for="SiliciumBreakoutsFront">
            Siliziumausbrüche Vorderseite?
          </label>
        </div>

        <!-- part for isSiliciumBreakoutsBack -->
        <div class="mb-2 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isSiliciumBreakoutsBack"
            value=""
            id="SiliciumBreakoutsBack"
          />
          <label class="form-check-label" for="SiliciumBreakoutsBack">
            Siliziumausbrüche Hinterseite?
          </label>
        </div>

        <!-- part for isEverythingGood -->
        <div class="mb-2 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isEverythingGood"
            value=""
            id="EverythingGood"
          />
          <label class="form-check-label" for="everythingGood">
            Gesamtergebnis i.O.?
          </label>
        </div>

        <!-- part for production line A / B -->
        <div class="form-group">
          <label class="mb-2">Produktionslinie: </label>
          <div v-for="(line, id) in lines" :key="id">
            <input
              type="radio"
              :id="id"
              v-model="selectedLine"
              :value="line.value"
              class="radio-input"
            />
            <label :for="id">{{ line.text }}</label>
          </div>
        </div>

        <!-- part for Notes-->
        <div class="form-group">
          <label class="mb-0" for="Notes">Bemerkungen</label>
          <input
            type="text"
            class="form-control"
            v-model="notes"
            id="Notes"
            placeholder="Silberpastenausbruch"
            required
          />
        </div>

        <button
          type="button"
          class="btn btn-primary mb-3 mt-4"
          @click="submit()"
        >
          Speichern
        </button>
      </form>

      <!-- success alert -->
      <transition name="alert">
        <div
          class="alert alert-success mt-1"
          role="alert"
          v-if="triggerSuccess"
        >
          Der Eintrag wurde gespeichert!
        </div>
      </transition>

      <!-- failed alert -->
      <transition name="alert">
        <div class="alert alert-danger mt-1" role="alert" v-if="triggerError">
          Eintrag konnte nicht gespeichert werden!
        </div>
      </transition>

      <!-- form invalid alert -->
      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerWarning"
        >
          Bitte füllen Sie alle Felder aus!
        </div>
      </transition>

      <!-- form invalid adhesiveForce alert -->
      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerInvalidAdhesiveForce"
        >
          Bitte füllen Sie die Haftkraftfelder richtig aus!
        </div>
      </transition>
    </div>

    <div class="col-md-9">
      <StringPeelTable :url="props.tableUrl" :key="componentKey" />
    </div>
  </div>

  <!-- not everyhting is good Modal part -->
  <transition name="modal">
    <template v-if="showModal && triggerNotEverythingGood">
      <MyModal :msg="modalNotEverythingGood" :visible="showModal">
        <template #success>
          <button
            type="button"
            id="success"
            class="btn btn-success"
            @click="handleModalButton(true)"
          >
            Speichern
          </button>
        </template>
        <template #declined>
          <button
            type="button"
            id="declined"
            class="btn btn-warning"
            @click="handleModalButton(false)"
          >
            Abbrechen
          </button>
        </template>
      </MyModal>
    </template>
  </transition>
</template>

<script setup>
import { onMounted, ref, defineProps } from "vue";
import StringPeelTable from "@/components/stringpeel/StringPeelTable.vue";
import MyModal from "@/components/helpers/MyModal.vue";
import moment from "moment-timezone";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  stationId: {
    type: Number,
    required: true,
  },
  tableUrl: {
    type: String,
    required: true,
  },
});

const componentKey = ref(0);
const modalNotEverythingGood =
  "Das Gesamtergebnis ist n.i.O.. Trotzdem speichern?";

let operator = ref();
let lines = ref([
  { id: 1, text: "Linie A", value: "A" },
  { id: 2, text: "Linie B", value: "B" },
]);
let selectedLine = ref("");

let isSiliciumBreakoutsBack = ref(false);
let isSiliciumBreakoutsFront = ref(false);
let isEverythingGood = ref(false);
let notes = ref("");
let lubricationFront = ref("");
let lubricationBack = ref("");
let adhesiveForceBack = ref("");
let adhesiveForceFront = ref("");

const operators = ref([]);

// trigger values for alerts
let triggerSuccess = ref(false);
let triggerError = ref(false);
let triggerWarning = ref(false);
let triggerInvalidAdhesiveForce = ref(false);
let triggerAbort = ref(false);
let triggerNotEverythingGood = ref(false);

let showModal = ref(false);
let modalResolve;

const handleModal = () => {
  showModal.value = true;
  return new Promise((resolve) => {
    modalResolve = resolve;
  });
};

const handleModalButton = (value) => {
  showModal.value = false;
  modalResolve(value);
};

onMounted(async () => {
  try {
    const { data } = await axios.get("/User/GetUsersByJobtype/2");
    operators.value = data
      .map(({ id, username }) => ({ id, username }))
      .sort((a, b) => a.username.localeCompare(b.username));
  } catch (error) {
    console.error("Erro ao carregar operadores:", error.message);
  }
});

// reset the form after submit it
function resetForm() {
  operator.value = null;
  notes.value = "";
  lubricationBack.value = "";
  lubricationFront.value = "";
  adhesiveForceBack.value = "";
  adhesiveForceFront.value = "";
  selectedLine.value = "";
  componentKey.value += 1;
  document.getElementById("SiliciumBreakoutsFront").checked = false;
  document.getElementById("SiliciumBreakoutsBack").checked = false;
  document.getElementById("EverythingGood").checked = false;
}

function extractAdhesiveForceValues(adhesiveForce) {
  if (adhesiveForce.includes("-")) {
    const parts = adhesiveForce.split("-");
    return {
      min: parseFloat(parts[0]),
      max: parseFloat(parts[1]),
    };
  } else if (!adhesiveForce.includes("-")) {
    triggerInvalidAdhesiveForce.value = true;
    return triggerInvalidAdhesiveForce.value;
  }
}

//  submit the form for adding a new string peel
async function submit() {
  const currentDate = moment().tz("Europe/Zurich").format();

  if (
    lubricationBack.value == "" ||
    lubricationFront.value == "" ||
    adhesiveForceBack.value == "" ||
    adhesiveForceFront.value == "" ||
    operator.value == null ||
    selectedLine.value == ""
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  }
  if (
    !adhesiveForceBack.value.includes("-") ||
    !adhesiveForceFront.value.includes("-")
  ) {
    // warning alert
    triggerInvalidAdhesiveForce.value = true;
    setTimeout(() => (triggerInvalidAdhesiveForce.value = false), 5000);
    return;
  }
  if (isEverythingGood.value === false) {
    triggerNotEverythingGood.value = true;
    const modalResult = await handleModal();
    if (!modalResult) {
      // abort alert
      triggerAbort.value = true;
      setTimeout(() => (triggerAbort.value = false), 5000);
      return;
    }
  }

  let adhesiveForceFrontValues = extractAdhesiveForceValues(
    adhesiveForceFront.value
  );
  let adhesiveForceBackValues = extractAdhesiveForceValues(
    adhesiveForceBack.value
  );

  let jsonObject = {
    operatorid: operator.value,
    stationid: props.stationId,
    dateInProduction: currentDate,
    adhesiveForceFrontMin: adhesiveForceFrontValues.min,
    adhesiveForceFrontMax: adhesiveForceFrontValues.max,
    adhesiveForceBackMin: adhesiveForceBackValues.min,
    adhesiveForceBackMax: adhesiveForceBackValues.max,
    lubricationFront: parseInt(lubricationFront.value),
    lubricationBack: parseInt(lubricationBack.value),
    isSiliciumBreakoutsFront: isSiliciumBreakoutsFront.value,
    isSiliciumBreakoutsBack: isSiliciumBreakoutsBack.value,
    isGood: isEverythingGood.value,
    manufacturingLine: selectedLine.value,
    notes: notes.value,
  };

  // json object for the POST-Request

  try {
    const { data } = await axios.post("/Material/AddStringPeel", jsonObject);
    console.log("Erfolgreiche Antwort:", data);
    resetForm();
  } catch (e) {
    console.log("Ein Fehler ist aufgetreten:", e.message);
    setTimeout(() => (triggerError.value = false), 5000);
    resetForm();
  }
  triggerSuccess.value = true;
  setTimeout(() => (triggerSuccess.value = false), 5000);
}
</script>

<style>
.alert-enter-active,
.alert-leave-active,
.modal-enter-active {
  transition: opacity 0.5s ease;
}
.alert-enter-from,
.alert-leave-to,
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

input[type="radio"] {
  transform: scale(1.3);
}
input[type="checkbox"] {
  transform: scale(1.2);
}
.radio-input {
  margin-right: 10px; /* Abstand zwischen dem Radio-Button und dem Label */
}
</style>
